var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.7488C4.54813 14.7488 1.75 11.9507 1.75 8.49878C1.75 5.0469 4.54813 2.24878 8 2.24878C11.4519 2.24878 14.25 5.0469 14.25 8.49878C14.25 11.9507 11.4519 14.7488 8 14.7488ZM8 13.4988C9.32608 13.4988 10.5979 12.972 11.5355 12.0343C12.4732 11.0966 13 9.82486 13 8.49878C13 7.1727 12.4732 5.90093 11.5355 4.96325C10.5979 4.02556 9.32608 3.49878 8 3.49878C6.67392 3.49878 5.40215 4.02556 4.46447 4.96325C3.52678 5.90093 3 7.1727 3 8.49878C3 9.82486 3.52678 11.0966 4.46447 12.0343C5.40215 12.972 6.67392 13.4988 8 13.4988ZM8.625 8.49878H11.125V9.74878H7.375V5.37378H8.625V8.49878Z",
    fill: "url(#paint0_linear_443_46962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_46962",
    x1: 8,
    y1: 14.7488,
    x2: 8,
    y2: 2.24878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTimeIcon);
export default __webpack_public_path__ + "static/media/playTimeIcon.49863ef87b62688db0f4dc0dc610af87.svg";
export { ForwardRef as ReactComponent };